define('presentation/common/callDetails/presentationObjects/callDetailsLocationPresentationObject',[],function() {
    return function(){
        const self = this;

        self.cityState = null;
        self.latitude = null;
        self.longitude = null;
        self.isExternal = false;
        self.phoneNumber = null;
    };
});

